import { getCustomReportData } from "./services/custom-report-services";

type TCustomReportCommentsResponse = Array<{ id: string; comments?: string[] }>;

/** Report row (material) id -> comments for exports; null when the request fails. */
export const fetchCommentsByReportRowId = async (
  reportId: string,
  projectToken: string
) => {
  const res = await getCustomReportData(reportId, projectToken, {
    include_comments: true
  });
  if (!res?.success || !Array.isArray(res.data)) return null;
  return new Map<string, string[]>(
    (res.data as TCustomReportCommentsResponse).map((row) => [
      row.id,
      row.comments ?? []
    ])
  );
};
